import { topSidePartOfWeb } from './parts/sideParts'

export const w2Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // バスケット部分
  ctx.beginPath()
  ctx.moveTo(250, 264) // 左上
  ctx.quadraticCurveTo(257, 275, 257, 275) // 左下1
  ctx.moveTo(250, 264) // 左上
  ctx.quadraticCurveTo(284, 198, 332, 151) // 右上1
  ctx.quadraticCurveTo(332, 151, 349, 245) // 右下1
  ctx.quadraticCurveTo(340, 258, 340, 258) // 右下＿左1
  // 区切りライン 横方向
  ctx.moveTo(257, 275) // 左
  ctx.quadraticCurveTo(334, 168, 334, 168) // 右
  ctx.moveTo(280, 268) // 左
  ctx.quadraticCurveTo(338, 189, 338, 189) // 右
  ctx.moveTo(303, 266) // 左
  ctx.quadraticCurveTo(342, 211, 342, 211) // 右
  ctx.moveTo(323, 261) // 左
  ctx.quadraticCurveTo(346, 229, 346, 229) // 右
  // 区切りライン 縦方向
  ctx.moveTo(264, 240) // 上
  ctx.quadraticCurveTo(280, 268, 280, 268) // 下
  ctx.moveTo(277, 219) // 上
  ctx.quadraticCurveTo(303, 267, 303, 267) // 下
  ctx.moveTo(295, 192) // 上
  ctx.quadraticCurveTo(323, 259, 323, 259) // 下
  ctx.moveTo(313, 172) // 上
  ctx.quadraticCurveTo(340, 258, 340, 258) // 下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // バスケットの周り
  // 内側
  ctx.moveTo(247, 265) //左上
  ctx.quadraticCurveTo(255, 279, 255, 279) // 左下
  ctx.quadraticCurveTo(342, 262, 342, 262) // 右下_左
  ctx.quadraticCurveTo(352, 243, 352, 243) // 右下_右
  ctx.quadraticCurveTo(334, 146, 334, 146) // 右上
  ctx.quadraticCurveTo(281, 194, 247, 265) // 左上
  // 外側
  ctx.moveTo(242, 265) //左上
  ctx.quadraticCurveTo(254, 282, 254, 282) // 左下
  ctx.quadraticCurveTo(344, 265, 344, 265) // 右下_左
  ctx.quadraticCurveTo(356, 241, 356, 241) // 右下_右
  ctx.quadraticCurveTo(336, 140, 336, 140) // 右上
  ctx.quadraticCurveTo(278, 191, 242, 265) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
}
